module.exports = __webpack_public_path__ + "media/images/number_13-da2ddd4b02d361f434a90ecf03dede69.png";